import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Wheat, ShoppingBag } from "lucide-react";
import { SHOPIER_URL } from "../lib/contact";

const links = [
  { to: "/", label: "Anasayfa", testId: "nav-home" },
  { to: "/egitimler", label: "Eğitimler", testId: "nav-trainings" },
  { href: SHOPIER_URL, label: "Ekmek Siparişi", testId: "nav-orders", external: true },
  { to: "/iletisim", label: "İletişim", testId: "nav-contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-md border-b"
      style={{ background: "rgba(253, 251, 247, 0.88)", borderColor: "var(--em-border)" }}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10 h-16 lg:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="brand-logo">
          <span
            className="inline-flex items-center justify-center w-9 h-9 rounded-full"
            style={{ background: "var(--em-terracotta-light)", color: "var(--em-terracotta-hover)" }}
          >
            <Wheat size={18} strokeWidth={1.75} />
          </span>
          <span className="font-serif text-lg lg:text-xl font-semibold tracking-tight text-[color:var(--em-espresso)]">
            Ekşi Maya Gurmesi
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) =>
            l.external ? (
              <a
                key={l.testId}
                href={l.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={l.testId}
                className="text-sm font-medium transition-colors text-[color:var(--em-espresso-soft)] hover:text-[color:var(--em-terracotta-hover)] inline-flex items-center gap-1.5"
              >
                {l.label}
              </a>
            ) : (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={l.testId}
                className={({ isActive }) =>
                  `text-sm font-medium transition-colors ${
                    isActive
                      ? "text-[color:var(--em-terracotta-hover)]"
                      : "text-[color:var(--em-espresso-soft)] hover:text-[color:var(--em-terracotta-hover)]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            )
          )}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={SHOPIER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-terracotta inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-semibold"
            data-testid="nav-order-btn"
          >
            <ShoppingBag size={16} /> Sipariş Ver
          </a>
          <Link
            to="/egitim-basvuru"
            className="inline-flex items-center text-sm font-semibold px-4 py-2.5 rounded-full border border-[color:var(--em-espresso)] text-[color:var(--em-espresso)] hover:bg-[color:var(--em-espresso)] hover:text-white transition-colors"
            data-testid="nav-apply-btn"
          >
            Eğitim Başvurusu
          </Link>
        </div>

        <button
          className="lg:hidden p-2 -mr-2 text-[color:var(--em-espresso)]"
          aria-label="Menüyü aç"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t" style={{ borderColor: "var(--em-border)", background: "var(--em-cream)" }} data-testid="nav-mobile-panel">
          <div className="px-5 py-5 flex flex-col gap-4">
            {links.map((l) =>
              l.external ? (
                <a
                  key={l.testId}
                  href={l.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setOpen(false)}
                  data-testid={`${l.testId}-mobile`}
                  className="text-base font-medium text-[color:var(--em-espresso-soft)]"
                >
                  {l.label}
                </a>
              ) : (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.to === "/"}
                  onClick={() => setOpen(false)}
                  data-testid={`${l.testId}-mobile`}
                  className={({ isActive }) =>
                    `text-base font-medium ${
                      isActive ? "text-[color:var(--em-terracotta-hover)]" : "text-[color:var(--em-espresso-soft)]"
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              )
            )}
            <div className="flex gap-3 pt-2">
              <a
                href={SHOPIER_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-terracotta flex-1 text-center px-4 py-3 rounded-full text-sm font-semibold"
                data-testid="nav-order-btn-mobile"
              >
                Sipariş Ver
              </a>
              <Link
                to="/egitim-basvuru"
                onClick={() => setOpen(false)}
                className="flex-1 text-center text-sm font-semibold px-4 py-3 rounded-full border border-[color:var(--em-espresso)] text-[color:var(--em-espresso)]"
                data-testid="nav-apply-btn-mobile"
              >
                Başvuru
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
